<template>
  <section class="cms-body">
    <el-form
      ref="form"
      :model="dataInfo"
      :rules="rules"
      class="cms-form"
      label-width="162px"
    >
      <el-form-item label="服务器编号" class="flex-50" prop="server_code">
        <el-input v-model="dataInfo.server_code"></el-input>
      </el-form-item>

      <el-form-item label="服务器名" class="flex-50" prop="server_name">
        <el-input v-model="dataInfo.server_name"></el-input>
      </el-form-item>

      <el-form-item label="IP地址" class="flex-50" prop="server_ip">
        <el-input v-model="dataInfo.server_ip"></el-input>
      </el-form-item>

      <el-form-item label="端口" class="flex-50" prop="server_port">
        <el-input v-model="dataInfo.server_port"></el-input>
      </el-form-item>
      <!--servertype-->
      <el-form-item label="服务器类型" class="flex-50" prop="stid">
        <el-select v-model="dataInfo.stid" placeholder="请选择">
          <el-option
            v-for="item in stypes"
            :key="item.stid"
            :label="item.stype_name"
            :value="item.stid"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 按钮组 -->
      <div class="form-footer">
        <el-button type="primary" @click="update()">
          修改
        </el-button>
        <el-button type="info" @click="$router.go(-1)">
          放弃修改
        </el-button>
        <el-button type="info" @click="reset">重置</el-button>
        <span class="gray">
          选择“修改”按钮，提交修改后将跳转到对应的列表页</span
        >
      </div>
    </el-form>
  </section>
</template>
<script>
import va from "@/rules";
import formMixns from "@/mixins/form";

export default {
  mixins: [formMixns], //普通表单变量
  data() {
    let required = va.required("此项必填");
    let number = va.number("只能输入数字");
    let address = va.ip("请输入正确的IP地址");
    let validateCode = va.validateCode("服务器编号已存在","Server/IsExist",this.$route.query.id);
    return {
      rules: {
        //校验规则
        server_name: [required],
        server_code: [required, validateCode],
        stid: [required, number],
        server_ip: [required, address],
        server_port: [required, number]
      },
      stypes: []
    };
  },
  methods: {
    update() {
      this.updateDataInfo(
        "Server/Update",
        this.dataInfo,
        "/server/list"
      );
    },
    add(state) {
      this.saveDataInfo(
        state,
        "Serverr/Insert",
        this.dataInfo,
        "/server/list"
      );
    },
    getDataInfo(id) {
      //重写获取表单数据
      this.$api
        .post("Server/Detail", { id: id })
        .then(res => {
          this.loading = true;
          if (res.status === 200) {
            this.loading = false;
            this.dataInfo = res.data.Data;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    reset() {
      this.getDataInfo(this.id);
    }
  },
  created() {
    //初始获取数据
    this.$api
      .post("ServerType")
      .then(res => {
        if (res.status === 200) {
          this.stypes = res.data.Data
        }
      })
      .catch(err => {
        console.log(err);
      });
    this.getDataInfo(this.id);
  }
};
</script>
